import {RecordForm} from '../forms/RecordForm';


import {useOrganizationAccount} from '../hooks/useOrganizationAccount';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";


export const AddPage = () => {

    const navigate = useNavigate();

    const {
        record,
        createRecord,
    } = useOrganizationAccount();

    return (
        <FormPageLayout
            title='Add Organization Account'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as any} handleSubmit={createRecord} handleCancel={() => navigate('/organization-accounts')}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
